// Mini editor rich-text para a nota extra do rótulo
// Usa contentEditable com botões de formatação

import React, { useRef, useCallback } from 'react';
import { Bold, Italic, Underline, AlignLeft, AlignCenter, AlignRight, Trash2 } from 'lucide-react';

export default function RichTextEditor({ value, onChange, placeholder }) {
  const editorRef = useRef(null);

  const execCmd = useCallback((cmd, val) => {
    editorRef.current && editorRef.current.focus();
    document.execCommand(cmd, false, val || null);
    // Propagar alteração
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  }, [onChange]);

  const handleInput = useCallback(() => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  }, [onChange]);

  // Inicializar conteúdo quando value muda externamente
  const handleRef = useCallback((el) => {
    editorRef.current = el;
    if (el && el.innerHTML !== (value || '')) {
      el.innerHTML = value || '';
    }
  }, [value]);

  const btnClass = "p-1.5 rounded hover:bg-slate-700 text-slate-400 hover:text-white transition-colors";

  return (
    <div className="border border-slate-700 rounded-lg overflow-hidden">
      {/* Toolbar */}
      <div className="flex items-center gap-0.5 px-2 py-1.5 bg-slate-800 border-b border-slate-700">
        <button type="button" onClick={() => execCmd('bold')} className={btnClass} title="Negrito (Cmd+B)">
          <Bold className="w-3.5 h-3.5" />
        </button>
        <button type="button" onClick={() => execCmd('italic')} className={btnClass} title="Italico (Cmd+I)">
          <Italic className="w-3.5 h-3.5" />
        </button>
        <button type="button" onClick={() => execCmd('underline')} className={btnClass} title="Sublinhado (Cmd+U)">
          <Underline className="w-3.5 h-3.5" />
        </button>
        <div className="w-px h-4 bg-slate-600 mx-1" />
        <button type="button" onClick={() => execCmd('justifyLeft')} className={btnClass} title="Alinhar esquerda">
          <AlignLeft className="w-3.5 h-3.5" />
        </button>
        <button type="button" onClick={() => execCmd('justifyCenter')} className={btnClass} title="Centrar">
          <AlignCenter className="w-3.5 h-3.5" />
        </button>
        <button type="button" onClick={() => execCmd('justifyRight')} className={btnClass} title="Alinhar direita">
          <AlignRight className="w-3.5 h-3.5" />
        </button>
        <div className="flex-1" />
        <button type="button" onClick={() => { if(editorRef.current) { editorRef.current.innerHTML=''; onChange(''); }}} className={btnClass} title="Limpar">
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      </div>
      {/* Área de edição */}
      <div
        ref={handleRef}
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        data-placeholder={placeholder || 'Escreve aqui...'}
        className="min-h-[80px] max-h-[200px] overflow-y-auto px-3 py-2 text-sm text-white bg-slate-900 focus:outline-none"
        style={{
          fontFamily: 'inherit',
          lineHeight: '1.5',
        }}
      />
      <style>{`
        [contenteditable]:empty:before {
          content: attr(data-placeholder);
          color: #4b5563;
          pointer-events: none;
        }
        [contenteditable] b, [contenteditable] strong { font-weight: bold; }
        [contenteditable] i, [contenteditable] em { font-style: italic; }
        [contenteditable] u { text-decoration: underline; }
      `}</style>
    </div>
  );
}
